import React from 'react';
import ReactDOM from 'react-dom';
import ImgIconComp from './../imgcomp';
import CustomAttribsConst from '../../constants/customAttributes.constants';
import { withTranslation } from 'react-i18next';

class UserDetailsPopup extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            custom_attribs:[],
        };
        this.handleClick = this.handleClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.clickArrow = this.clickArrow.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
		let this_ = this;
		let userId = this.props.userId;
		if(userId){
			$.ajax({
	            url: wbConfig.baseUrl + "/board/getUserCustomAttributes",
	            type: 'POST',
	            dataType: 'json',
	            data: {userId: userId},
	        })
            .done(function (data) {
                let custom_attribs = data.custom_attribs.map(item => {
		            item.display = true;
		            item.attributes.map(filed => {
		            	filed.display = false;
		            });
		            return item;
		        });
		        this_.setState({
                	custom_attribs:custom_attribs
                })
            })
	    }

		window.addEventListener("click", this.handleClick, true);
        this.forceUpdate();
	}

    handleClick(e){
	    if (!$('.popupClick').is(e.target) // if the target of the click isn't the container...
	        && $('.popupClick').has(e.target).length === 0) {
	        let custom_attribs = this.state.custom_attribs.map(item => {
	            item.attributes.map(filed => {
	            	filed.display = false;
	            });
	            return item;
	        });
	    	this.forceUpdate();
	    }
    }

	closePopup(){
		if (typeof this.props.onClose === 'function') {
			this.props.onClose();
		}
		else {
			this.mountId = document.getElementById('wsEditPopup');
			if(this.mountId){
			 ReactDOM.unmountComponentAtNode(this.mountId);
			}
			$('#wsEditPopup').dialog('close');
		}
    }

    clickArrow(id,status){
    	let status_ = !status;
        let attributes = this.state.custom_attribs.map(item => {
            if(item.id == id){
                item.display = status_;
            }
            return item;
        });
        this.forceUpdate();
    }

    openPopup(id){
    	let custom_attribs = this.state.custom_attribs.map(item => {
            	item.attributes.map(filed => {
            		if(filed.id == id){
            			filed.display = !filed.display;
            		}
            	
            });
            return item;
        });
        this.forceUpdate();	
    }

    changeValue(e,field_id,field_type,sel_value=""){
    	let _this = this;
    	let ca_value = '';
    	let custom_attribs = this.state.custom_attribs.map(item => {
    			
            	item.attributes.map(filed => {
            		if(filed.id == field_id){
            			if(field_type == 1 || field_type == 2 ){
            				 ca_value = e.target.value;
            				 filed.ca_value = ca_value;
						}
						if(field_type == 3){
							ca_value = $(e.target).text();
							filed.ca_value = ca_value;
						}
						if(field_type == 4){
							//let sel = e.target.value;
							filed.ca_value = sel_value;
							ca_value = filed.ca_value ;
						}
            		}
            	return filed;
            	});
            return item;
        });

        this.forceUpdate();
        this.saveValue(field_id,ca_value,field_type);
    }

    saveValue(field_id,ca_value,field_type){
       	let params = {
       		objectId			: this.props.userId,  
       		type 				: CustomAttribsConst.OBJECT_TYPE_USER, 
       		customAttributeId 	: field_id, 
       		customAttrbuteValue	: ca_value
       	};
        $.post(wbConfig.baseUrl + '/activity/saveCustomAttributeObejctMap', params , function(response, status) {
        })
    }

    render(){
		const { t } = this.props;
		let custom_attribs = this.state.custom_attribs;
		let userDet = this.props.item;
		let userOffset = this.props.boardDetails.user.currentDate.userOffset;
		let availabilityDate = "";
		if(userDet.user_availabilty_date){
		        let _timestamp = parseInt(userDet.user_availabilty_date);
		        let _userOffset = userOffset || 0;
		        if(typeof _userOffset !== 'undefined' && _userOffset !== null){
		            _timestamp = _timestamp + parseInt(_userOffset);
		        }
		        availabilityDate = moment.utc(_timestamp * 1000).format("D/M/Y");
		    }
		custom_attribs = custom_attribs.sort((a, b) =>  b.id - a.id);
		return(
			<div className="userPopupWrap">
				
					<div className="editHead"  >
                        <div className="boxs headTextLine" >
                        	<div className="rectbox-col user-pic inline-block" >
			                    <img src={userDet.picture} className="roundFramePhoto team-meeting-attendee-pic fitProfileImage" width="35" height="35" title=""/>
			                </div>
			                <div className="nameWrap truncateText">
	                            <div className="userName">{userDet.firstname + " " + userDet.lastname}</div>
	                            <div className="userType">{userDet.title}</div>
	                        </div>
                            <div className="avilableBox">
                            	<div className="inline-block avlText">{t("Available")}:</div>
                            	<div className="date inline-block" >{availabilityDate}</div>
                            	<div className="inline-block calnImd"><img style={{width:'15px'}} src={wbConfig.imageCdnUrl+"/images/icons/edit_images/due_grey.png"}/></div>
                            </div>
                        </div>
                        <div className={"closePopup right clickable displayInline"} onClick={this.closePopup}>
                            <ImgIconComp id="close" />
                        </div>
                    </div>
                     
                    <div className="userAttr verticalScroll peoplePopup">
                    {  custom_attribs.length > 0 && custom_attribs.map((cate, index) => (
		                    <div className="popupBoady ">
		                    	<div className="boadyHead">
		                    		<div className="headName displayInline truncateText" title={cate.name}>{cate.name}</div>
		                    		<div className="arrowImage displayInline" onClick={(e) => this.clickArrow(cate.id,cate.display)}><ImgIconComp id={cate.display ? "arrow_up_gray" : "arrow_down_gray"} width="10" height="8" /></div>
		                    	</div>
		                    	{ 
		                    		(cate.display) ? 

				                    	<div className="content">
				                    		{
				                    			cate.attributes.map((field,index) => (
						                    		  
						                    		<div key={`cat_${index}`} className="attrfield">
						                    			<div className="fieldName truncateText" title={field.name}>{field.name}</div>
							                    			{ field.field_type_id == 1  ?
							                    				<div className="filedType truncateText">
							                    					{ field.canEdit &&
							                    					<input type="text" value={field.ca_value} className="textFiled" onChange={(e) => this.changeValue(e,field.id,field.field_type_id) } placeholder={t("Enter the value")}/>
							                    					}
							                    					{
							                    						!field.canEdit &&
							                    						<div className="textFiled" title={field.ca_value} style={{border:"none"}}>{(field.ca_value =='' || field.ca_value==null) ? '--':field.ca_value}</div>
							                    					}
							                    				</div>
							                    			:""
							                    			}

							                    			{ field.field_type_id == 2  ?
							                    				<div className="filedType truncateText" >
						                    					{ field.canEdit &&
								                    				<textarea onChange={(e) => this.changeValue(e,field.id,field.field_type_id) } className="teaxtArea" placeholder={t("Enter the value")} value={field.ca_value} />
										                        }

										                        {
										                        	!field.canEdit &&
						                    						<div className="teaxtArea" title={field.ca_value} style={{border:"none"}}>{(field.ca_value=='' || field.ca_value==null) ? '--':field.ca_value}</div>
										                        }
							                    				</div>
							                    			:""
							                    			}

							                    			{ field.field_type_id == 3 ?
							                    					<div className="filedType dropdown">
							                    					{ field.canEdit &&
									                    				<div >
									                    					<div className="selFieldType popupClick " onClick={(e) => this.openPopup(field.id)}>
					                    	                            		<div className="truncateText multiSelDrop" style={{display:"inline-block"}}>{(field.ca_value)? field.ca_value: "-- Select Values --"} </div><ImgIconComp class="dropDIcon" id="arrow_down_gray" width="13" height="10" />
					                    	                            	</div>
					                    	                            	{ field.display  && 
									                    						<FieldDropDownList fields={field.field_values}  changeValue={this.changeValue} field_id={field.id}/>
					                    	                            	}
									                    				</div>
									                    			}
									                    			{
									                    				!field.canEdit &&
									                    				<div className="textFiled" title={field.ca_value} style={{border:"none"}}>{(field.ca_value =='' || field.ca_value==null) ? '--':field.ca_value}</div>
									                    			}
									                    			</div>
							                    			:""
							                    			}

							                    			{ field.field_type_id == 4  ?
							                    				<div className="filedType dropdown ">
							                    				{ field.canEdit &&
								                    				<div >
								                    					<div className="selFieldType popupClick multiSelDrop" onClick={(e) => this.openPopup(field.id)}>
				                    	                            		<div className="truncateText" style={{display:"inline-block"}}>{(field.ca_value)? field.ca_value: "-- Select Values --"} </div><ImgIconComp class="dropDIcon" id="arrow_down_gray" width="13" height="10" />
				                    	                            	</div>
				                    	                            	{ field.display  && 
				                    	                            		<ListMultiCategory     fields={field.field_values}  field_id={field.id}  changeValue={this.changeValue}/>
				                    	                            	}
								                    				</div>
								                    			}
								                    			{
								                    				!field.canEdit &&
								                    				<div className="textFiled" title={field.ca_value} style={{border:"none"}}>{(field.ca_value =='' || field.ca_value==null) ? '--':field.ca_value}</div>
								                    			}
								                    			</div>
							                    				
							                    			:""
							                    			}
						                    		</div>
					                    		))
					                    	}


				                    		

				                    	</div>
			                    	:""
		                    	}
		                    </div>
	                  ))
                	}
                	</div>
                
			</div>
		)
	}
}

class FieldDropDownList extends React.Component{

    constructor(props){
        super(props);
    }

    render(){
        let selFieldType = this.props.fields;
        let field_id = this.props.field_id;
        return (
                <div className="typeSelectWrap">
                 {
                 	selFieldType.map((item, index) => (
                 		<div key={`field_${field_id}_index`} className="option popupClick" onClick={(e) =>this.props.changeValue(e,field_id,3)} >{item.value}</div>
                 	))
                 }
                </div>
           )
    }
}

class ListMultiCategory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fields : this.props.fields
        };
        this.changeValue = this.changeValue.bind(this);
    }    

    changeValue(e,index){
		let _this = this;
		let field_id = this.props.field_id;
		let fields = this.state.fields.map((field,i) => {
			if(index == i){
				let st = field.checkItem
				if(st == true){
					field.checkItem = false;
				}else{
					field.checkItem = true;
				}
			}
			return field;
		})
		setTimeout(() => _this.setState({ 
				fields:fields,
        }), 10);
        let sel_value= [];
        this.state.fields.map((field,i) => {
			if(field.checkItem){
				sel_value.push(field.value);
			}
		})
        this.props.changeValue(e,field_id,4,sel_value.toString());
		
    }
    
	render(){
		let fields = this.state.fields;
		let field_id = this.props.field_id;
		return (
			<div className="typeSelectWrap">
				{
					fields.map((field,index) => (
						<div key={'fvalue_${field_id}_${index}'} data-value={field.checkItem} className="option">
						{ field.checkItem &&
							<div>
							<input type="checkbox" className="popupClick grp-meeting-attendee-select" checked  value={field.value} onChange={(e)=>this.changeValue(e,index)} /><label>{field.value}</label>
							</div>
						}
						{ !field.checkItem &&
							<div>
							<input type="checkbox" className="popupClick grp-meeting-attendee-select"   value={field.value} onChange={(e)=>this.changeValue(e,index)} /><label>{field.value}</label>
						</div>
						}
						</div>
					))
				}
			</div>
		)
	}

}
		                    			

export default withTranslation()(UserDetailsPopup);